<template>
    <div class="d-flex align-items-center justify-content-between mb-2">
        <div>
            {{ translate('RecordManager.label.results') }}: {{ filteredRecords.length }}
        </div>

        <div>
            <input @keyup="filterRecords" class="form-control" type="text" :placeholder="translate('RecordManager.label.filter_results_placeholder')" size="35" v-model="filterQuery" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: { type: Number, required: true },
            records: { type: Array, required: true },
            recordFieldsToFilter: { type: Array, required: false }
        },

        data() {
            return {
                filterQuery: '',
                filteredRecords: this.records
            }
        },

        methods: {
            filterRecords() {
                if (this.filterQuery == '') {
                    this.filteredRecords = this.records;
                } else {
                    this.filteredRecords = [];

                    for (let index = 0; index < this.records.length; index++) {
                        // make a deep copy of the record
                        let recordToFilter = Object.assign({}, this.records[index]);

                        let matchFound = false;
                        for (let fieldName in recordToFilter) {
                            if (this.recordFieldsToFilter.indexOf(fieldName) > -1) {
                                // check whether the field value is an object
                                let isTypeOfObject = typeof recordToFilter[fieldName] === 'object' && recordToFilter[fieldName] !== null;
                                // assume that field values of type object have a 'label' property to use for filtering
                                let fieldValue = isTypeOfObject ? recordToFilter[fieldName]['label'] : recordToFilter[fieldName];
                                // check whether the filter query string matches a part of the field value
                                if (fieldValue && fieldValue.toLowerCase().indexOf(this.filterQuery.toLowerCase()) >= 0) {
                                    // highlight the field value in the cloned record
                                    if (isTypeOfObject) {
                                        // make a deep copy of the field value object
                                        let fieldValueObject = Object.assign({}, recordToFilter[fieldName]);
                                        fieldValueObject['label'] = this.highlight(fieldValue, this.filterQuery);
                                        recordToFilter[fieldName] = fieldValueObject;
                                    } else {
                                        recordToFilter[fieldName] = this.highlight(fieldValue, this.filterQuery);
                                    }
                                    matchFound = true;
                                }
                            }
                        }

                        if (matchFound) {
                            this.filteredRecords.push(recordToFilter);
                        }
                    }
                }

                EventDispatcher.fire('filterRecordsByFilterQuery' + this.id, {
                    filterQuery: this.filterQuery,
                    filteredRecords: this.filteredRecords
                });
            },

            highlight(value, filterQuery, startHighlightTag = '<mark>', endHighlightTag = '</mark>') {
                return value.replace(new RegExp(filterQuery, 'gi'), str => `${startHighlightTag}${str}${endHighlightTag}`);
            }
        }
    }
</script>